// Mock data for Enjaz Commercial Services website

export const companyInfo = {
  name: "Enjaz Commercial Services and Management Consultancy",
  shortName: "Enjaz",
  tagline: "Trusted Partner for Qatar's Business Success",
  description: "Leading provider of commercial services and management consultancy in Qatar, delivering innovative solutions for business growth and operational excellence.",
  
  contact: {
    email: "enjazcs.qa@gmail.com",
    phone1: "40011158",
    phone2: "66663237",
    address: "Birkat Al Awamer - Zone 91 - Street 3085 - Building 211 - Office 4",
    pobox: "220092",
    city: "Doha",
    country: "Qatar"
  },
  
  hero: {
    title: "Excellence in Commercial Services & Management Solutions",
    subtitle: "Transform your business with strategic consulting and comprehensive commercial services tailored to your success",
    cta: "Get Started",
    ctaSecondary: "Our Services"
  },
  
  services: [
    {
      id: 1,
      title: "Management Consultancy",
      description: "Strategic planning, organizational development, and performance optimization to drive sustainable business growth.",
      icon: "target"
    },
    {
      id: 2,
      title: "Commercial Services",
      description: "Comprehensive commercial solutions including business setup, licensing, and regulatory compliance management.",
      icon: "briefcase"
    },
    {
      id: 3,
      title: "Business Strategy",
      description: "Data-driven insights and strategic frameworks to help you make informed decisions and achieve competitive advantage.",
      icon: "trendingUp"
    },
    {
      id: 4,
      title: "Financial Advisory",
      description: "Expert financial planning, analysis, and advisory services to optimize your business financial performance.",
      icon: "dollarSign"
    },
    {
      id: 5,
      title: "Operations Management",
      description: "Streamline your operations with proven methodologies and best practices for efficiency and productivity.",
      icon: "settings"
    },
    {
      id: 6,
      title: "HR Consulting",
      description: "Human resource management solutions including recruitment, training, and organizational development.",
      icon: "users"
    },
    {
      id: 7,
      title: "Government Transactions Clearance",
      description: "Expert handling of all government-related transactions, documentation, and regulatory clearances in Qatar.",
      icon: "fileText"
    },
    {
      id: 8,
      title: "Company Establishment",
      description: "Complete support for establishing Qatari and foreign-invested companies with full legal and regulatory compliance.",
      icon: "building"
    },
    {
      id: 9,
      title: "Administrative Planning",
      description: "Comprehensive administrative planning services to optimize organizational structure and workflow efficiency.",
      icon: "clipboardList"
    },
    {
      id: 10,
      title: "Financial Planning",
      description: "Strategic financial planning and budgeting services to ensure long-term financial stability and growth.",
      icon: "pieChart"
    },
    {
      id: 11,
      title: "Economic Feasibility Studies",
      description: "In-depth economic analysis and feasibility studies to evaluate investment opportunities and market potential.",
      icon: "barChart"
    },
    {
      id: 12,
      title: "Financial Feasibility Studies",
      description: "Detailed financial feasibility assessments to determine project viability and return on investment.",
      icon: "calculator"
    },
    {
      id: 13,
      title: "Financial Auditing",
      description: "Professional financial auditing services ensuring compliance, accuracy, and transparency in financial reporting.",
      icon: "searchCheck"
    },
    {
      id: 14,
      title: "Financial Analysis",
      description: "Comprehensive financial analysis and reporting to support strategic decision-making and business planning.",
      icon: "lineChart"
    },
    {
      id: 15,
      title: "Commercial Brokerage",
      description: "Professional brokerage services connecting businesses with opportunities and facilitating commercial transactions.",
      icon: "handshake"
    }
  ],
  
  about: {
    title: "About Enjaz",
    description: "Enjaz Commercial Services and Management Consultancy is a trusted partner for businesses seeking excellence in Qatar. We combine deep industry expertise with innovative approaches to deliver tailored solutions that drive measurable results.",
    mission: "To empower businesses with world-class commercial services and strategic consulting that creates lasting value and competitive advantage.",
    vision: "To be the most trusted and innovative commercial services and management consultancy firm in the region.",
    values: [
      {
        title: "Excellence",
        description: "We strive for excellence in every service we deliver",
        key: "excellence"
      },
      {
        title: "Integrity",
        description: "We conduct business with the highest ethical standards",
        key: "integrity"
      },
      {
        title: "Innovation",
        description: "We embrace innovative solutions to solve complex challenges",
        key: "innovation"
      },
      {
        title: "Partnership",
        description: "We build long-term relationships based on trust and results",
        key: "partnership"
      }
    ]
  },
  
  stats: [
    {
      number: "500+",
      label: "Projects Completed",
      key: "projects"
    },
    {
      number: "800+",
      label: "Happy Clients",
      key: "clients"
    },
    {
      number: "2+",
      label: "Years Experience",
      key: "experience"
    },
    {
      number: "98%",
      label: "Client Satisfaction",
      key: "satisfaction"
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Ahmed Al-Mansoori",
      position: "CEO, Tech Solutions Qatar",
      text: "Enjaz transformed our business operations with their strategic consulting. Their expertise and professionalism are unmatched.",
      rating: 5
    },
    {
      id: 2,
      name: "Sarah Williams",
      position: "Managing Director, Global Trade Co.",
      text: "The commercial services provided by Enjaz made our business setup seamless. Highly recommended for any company in Qatar.",
      rating: 5
    },
    {
      id: 3,
      name: "Mohammed Al-Thani",
      position: "Founder, Innovative Ventures",
      text: "Their management consultancy services helped us achieve 40% growth in just one year. Exceptional team and results.",
      rating: 5
    }
  ]
};
